import React from 'react';
import './App.css';
import EnergyDashboard from './components/EnergyDashboard';

const App: React.FC = () => {

  return (
    <div className="App">
      <header className="App-header">
        <h1>Sunny Side Energy Readings </h1>
      </header>
      <main>
        <EnergyDashboard />
      </main>
    </div>
  );
};

export default App;
